import { IntlShape } from 'react-intl'
import { create, omitWhen } from 'vest'
import {
  RegularBenefitVariant,
  RegularFreeShipping,
} from '../../../../../../../typings'
import { validationShippingVariantSuite } from '../../../../../../ShippingVariantSelector/validation'

export function validationSuiteFreeShipping(intl: IntlShape) {
  return create((props: RegularFreeShipping) => {
    const { type } = props

    omitWhen(type !== RegularBenefitVariant.FreeShipping, () => {
      validationShippingVariantSuite(intl)(props as RegularFreeShipping)
    })
  })
}
